import { Observable } from 'rxjs';
import {
  GestorAssignResult,
  GestorServicesResult,
  GestorUpdateResult,
} from '@app/domain/models/tpv/gestor.model';
import {
  AssignGestorRequest,
  UpdateGestorRequest,
} from '@app/data/dtos/tpv/gestor.dto';

/**
 * Port para los gestores genéricos (`/api/gestor/*`, API principal, IsAdminUser).
 * Da/consulta/edita autoridad sobre cuentas que YA existen (SPEI/Cards/TPV).
 */
export abstract class GestorRepository {
  /** Alta de gestor (`POST /api/gestor/assign/`). */
  abstract assign(request: AssignGestorRequest): Observable<GestorAssignResult>;

  /** Lista los gestores/servicios de una cuenta (`GET /api/gestor/services/`). */
  abstract listServices(
    polipayAccount: string,
    includeInactive?: boolean,
  ): Observable<GestorServicesResult>;

  /** Cambia rol y/o activa-desactiva un gestor (`PUT /api/gestor/update/`). Idempotente. */
  abstract update(request: UpdateGestorRequest): Observable<GestorUpdateResult>;
}
